interface ContactSupportOptions {
    /** Subject to pre-populate */
    subject?: string;
    /** Message to pre-populate */
    message?: string;
    /** Reason for contacting the support */
    reason?: ContactSupportReasons;
}

export type ContactSupportFn = (options?: ContactSupportOptions) => Promise<void>;

export enum ContactSupportReasons {
    QUESTION = 'I have a question',
    BILLING_ISSUE = 'I have a billing issue',
    REQUEST_FEATURE = 'I want to request a feature',
    APPLY_FOR_COMMUNITY = "I'm interested in a Community plan",
}
